module.exports = __webpack_public_path__ + "static/media/1f44f.d86b68ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f44f.svg
// module id = 619
// module chunks = 1